/* tslint:disable */
/* auto-generated angular directive proxies */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';

import { ProxyCmp, proxyOutputs } from './angular-component-lib/utils';

import { Components } from '../ds-components-intapps-angular';


@ProxyCmp({
  inputs: ['absolute', 'childrenWidth', 'customMaxHeight', 'internalClass', 'internalId', 'isChildrenInert', 'isExpanded', 'isLoading', 'overflowYScroll', 'position', 'promoteZIndexId', 'scrollToIndex']
})
@Component({
  selector: 'srsa-accordion',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['absolute', 'childrenWidth', 'customMaxHeight', 'internalClass', 'internalId', 'isChildrenInert', 'isExpanded', 'isLoading', 'overflowYScroll', 'position', 'promoteZIndexId', 'scrollToIndex'],
})
export class SrsaAccordion {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['srsaAccordionTransitionendEvent']);
  }
}


import type { InternalCustomEvent as ISrsaAccordionInternalCustomEvent } from '../ds-components-intapps-angular';

export declare interface SrsaAccordion extends Components.SrsaAccordion {
  /**
   * Custom event emitter that takes the incoming transitionend event and wraps it in a CustomEvent
along with the unique id of the component instance and the collapsed/expanded state.
Triggered by @Listen cssTransitionendEventHandler,@param event - The transitionend event from max-height transition of the accordion
   */
  srsaAccordionTransitionendEvent: EventEmitter<CustomEvent<ISrsaAccordionInternalCustomEvent<TransitionEvent, string>>>;
}


@ProxyCmp({
  inputs: ['actionText', 'autoHide', 'descriptionText', 'hideDuration', 'internalClass', 'internalId', 'leadingIcon', 'position', 'titleText', 'trailingIcon', 'type']
})
@Component({
  selector: 'srsa-alert',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['actionText', 'autoHide', 'descriptionText', 'hideDuration', 'internalClass', 'internalId', 'leadingIcon', 'position', 'titleText', 'trailingIcon', 'type'],
})
export class SrsaAlert {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['srsaAlertButtonClicked']);
  }
}


import type { InternalCustomEvent as ISrsaAlertInternalCustomEvent } from '../ds-components-intapps-angular';

export declare interface SrsaAlert extends Components.SrsaAlert {
  /**
   * Used to notify listeners that the alert action button was clicked.
   */
  srsaAlertButtonClicked: EventEmitter<CustomEvent<ISrsaAlertInternalCustomEvent<PointerEvent, string>>>;
}


@ProxyCmp({
  inputs: ['badgeLabel', 'classes', 'disabled', 'href', 'internalAriaLabel', 'internalClass', 'internalId', 'internalLabel', 'internalType', 'isLoading', 'leadingIcon', 'trailingIcon']
})
@Component({
  selector: 'srsa-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['badgeLabel', 'classes', 'disabled', 'href', 'internalAriaLabel', 'internalClass', 'internalId', 'internalLabel', 'internalType', 'isLoading', 'leadingIcon', 'trailingIcon'],
})
export class SrsaButton {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['srsaButtonClicked']);
  }
}


import type { InternalCustomEvent as ISrsaButtonInternalCustomEvent } from '../ds-components-intapps-angular';

export declare interface SrsaButton extends Components.SrsaButton {
  /**
   * A unique event generated on button click identified by the internalId.
Is generated alongside (and not overwriting) the default click event.

The event name is the name of the method: srsaButtonClicked. This can be
overridden with @Event ({eventName: 'custom name'}) if desired

The custom event will contain a detail property, that contains the object passed
in as the argument for .emit(). This object contains the custom unique id of the
custom element instance, as well as the PointerEvent contents. This allows
a listener for srsaButtonClicked events to filter for specific buttons with this id.

The event cannot be named after the custom id itself while using Stencil's,@Event decorator,
as that is generated after the event definition is already processed.

Can be listened to via,@Listen https://stenciljs.com/docs/events#listen-decorator
   */
  srsaButtonClicked: EventEmitter<CustomEvent<ISrsaButtonInternalCustomEvent<PointerEvent, string>>>;
}


@ProxyCmp({
  inputs: ['disabled', 'indeterminate', 'internalAriaLabel', 'internalClass', 'internalId', 'isLoading', 'label', 'required', 'tooltip', 'value']
})
@Component({
  selector: 'srsa-checkbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled', 'indeterminate', 'internalAriaLabel', 'internalClass', 'internalId', 'isLoading', 'label', 'required', 'tooltip', 'value'],
})
export class SrsaCheckbox {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['srsaCheckboxChange']);
  }
}


import type { InternalCustomEvent as ISrsaCheckboxInternalCustomEvent } from '../ds-components-intapps-angular';
import type { ElementEvent as ISrsaCheckboxElementEvent } from '../ds-components-intapps-angular';

export declare interface SrsaCheckbox extends Components.SrsaCheckbox {
  /**
   * A unique event generated on change identified by the internalId.
Is generated alongside (and not overwriting) the default change event.

The event name is the name of the method: srsaCheckboxChange. This can be
overridden with @Event ({eventName: 'custom name'}) if desired

The custom event will contain a detail property, that contains the object passed
in as the argument for .emit(). This object contains the custom unique id of the
custom element instance, as well as the PointerEvent contents. This allows
a listener for srsaCheckboxChange events to filter for checkboxes with this id.

The event cannot be named after the custom id itself while using Stencil's,@Event decorator,
as that is generated after the event definition is already processed.

Can be listened to via,@Listen https://stenciljs.com/docs/events#listen-decorator
   */
  srsaCheckboxChange: EventEmitter<CustomEvent<ISrsaCheckboxInternalCustomEvent<ISrsaCheckboxElementEvent<HTMLInputElement> | CustomEvent, boolean>>>;
}


@ProxyCmp({
  inputs: ['buttonIcon', 'disabled', 'internalAriaLabel', 'internalClass', 'internalId', 'internalLabel', 'isClickable', 'isLoading']
})
@Component({
  selector: 'srsa-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['buttonIcon', 'disabled', 'internalAriaLabel', 'internalClass', 'internalId', 'internalLabel', 'isClickable', 'isLoading'],
})
export class SrsaChip {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['srsaChipButtonClicked']);
  }
}


import type { InternalCustomEvent as ISrsaChipInternalCustomEvent } from '../ds-components-intapps-angular';

export declare interface SrsaChip extends Components.SrsaChip {
  /**
   * A unique event generated on button click identified by the internalId.
Is generated alongside (and not overwriting) the default click event.

The event name is the name of the method: srsaChipButtonClicked. This can be
overridden with @Event ({eventName: 'custom name'}) if desired

The custom event will contain a detail property, that contains the object passed
in as the argument for .emit(). This object contains the custom unique id of the
custom element instance, as well as the PointerEvent contents. This allows
a listener for srsaChipButtonClicked events to filter for specific buttons with this id.

The event cannot be named after the custom id itself while using Stencil's,@Event decorator,
as that is generated after the event definition is already processed.

Can be listened to via,@Listen https://stenciljs.com/docs/events#listen-decorator
   */
  srsaChipButtonClicked: EventEmitter<CustomEvent<ISrsaChipInternalCustomEvent<PointerEvent, string>>>;
}


@ProxyCmp({
  inputs: ['columnDefinitions', 'dataSource', 'gridStyling', 'internalId', 'isLoading', 'isRowButtonBehavior', 'shouldHideHeaderRow', 'shouldMultiSort', 'shouldSort', 'sortValues']
})
@Component({
  selector: 'srsa-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['columnDefinitions', 'dataSource', 'gridStyling', 'internalId', 'isLoading', 'isRowButtonBehavior', 'shouldHideHeaderRow', 'shouldMultiSort', 'shouldSort', 'sortValues'],
})
export class SrsaGrid {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['change', 'srsaGridSortChange', 'srsaGridRowSelect']);
  }
}


import type { InternalCustomEvent as ISrsaGridInternalCustomEvent } from '../ds-components-intapps-angular';
import type { SrsaSortValue as ISrsaGridSrsaSortValue } from '../ds-components-intapps-angular';
import type { SrsaGridRowData as ISrsaGridSrsaGridRowData } from '../ds-components-intapps-angular';

export declare interface SrsaGrid extends Components.SrsaGrid {
  /**
   * Emits the change event, which provides the updated sort, or updated filter, or updated pagination value.
This allows a single event listener to get updates on all the types of changes grid can emit; individual
events are emitted below.
   */
  change: EventEmitter<CustomEvent<ISrsaGridInternalCustomEvent<PointerEvent, ISrsaGridSrsaSortValue[]>>>;
  /**
   * Emits the custom srsaGridSortChange event, which provides the updated sort.
This is equivalent to the "change" event
   */
  srsaGridSortChange: EventEmitter<CustomEvent<ISrsaGridInternalCustomEvent<PointerEvent, ISrsaGridSrsaSortValue[]>>>;
  /**
   * Emits the custom srsaGridRowSelect event, which provides the data used to generate the row
   */
  srsaGridRowSelect: EventEmitter<CustomEvent<ISrsaGridInternalCustomEvent<MouseEvent | KeyboardEvent, ISrsaGridSrsaGridRowData>>>;
}


@ProxyCmp({
  inputs: ['buttonConfig', 'classes', 'disabled', 'dropdownContainerConfig', 'internalAriaLabel', 'internalId', 'isLoading', 'options']
})
@Component({
  selector: 'srsa-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['buttonConfig', 'classes', 'disabled', 'dropdownContainerConfig', 'internalAriaLabel', 'internalId', 'isLoading', 'options'],
})
export class SrsaMenu {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['change', 'srsaMenuOptionClicked']);
  }
}


import type { InternalCustomEvent as ISrsaMenuInternalCustomEvent } from '../ds-components-intapps-angular';

export declare interface SrsaMenu extends Components.SrsaMenu {
  /**
   * Emits the change event, which passes on the pointer event
emitted by srsa-button clicks
   */
  change: EventEmitter<CustomEvent<ISrsaMenuInternalCustomEvent<PointerEvent, string>>>;
  /**
   * Emits the custom srsaMenuOptionClicked event, which passes on the pointer event
emitted by srsa-button clicks.

The option id selected can be pulled from event.detail.event.currentTarget.id
   */
  srsaMenuOptionClicked: EventEmitter<CustomEvent<ISrsaMenuInternalCustomEvent<PointerEvent, string>>>;
}


@ProxyCmp({
  inputs: ['absolute', 'customClassString', 'headerText', 'horizontalRule', 'internalId', 'isDialog', 'preventBackgroundScroll', 'show', 'showCloseButton']
})
@Component({
  selector: 'srsa-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['absolute', 'customClassString', 'headerText', 'horizontalRule', 'internalId', 'isDialog', 'preventBackgroundScroll', 'show', 'showCloseButton'],
})
export class SrsaModal {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['srsaModalChange', 'change']);
  }
}


import type { InternalCustomEvent as ISrsaModalInternalCustomEvent } from '../ds-components-intapps-angular';

export declare interface SrsaModal extends Components.SrsaModal {
  /**
   * Bubbles up events from the modal, primarily passing on events bubbled up
from the <slot>
   */
  srsaModalChange: EventEmitter<CustomEvent<ISrsaModalInternalCustomEvent<CustomEvent, unknown>>>;
  /**
   * Duplicate of srsaModalChange, following usual component event emission pattern
   */
  change: EventEmitter<CustomEvent<ISrsaModalInternalCustomEvent<CustomEvent, unknown>>>;
}


@ProxyCmp({
  inputs: ['classes', 'disabled', 'internalId', 'isLoading', 'isPrimary', 'options']
})
@Component({
  selector: 'srsa-navbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['classes', 'disabled', 'internalId', 'isLoading', 'isPrimary', 'options'],
})
export class SrsaNavbar {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['srsaNavbarLinkClicked']);
  }
}


import type { InternalCustomEvent as ISrsaNavbarInternalCustomEvent } from '../ds-components-intapps-angular';

export declare interface SrsaNavbar extends Components.SrsaNavbar {
  /**
   * EventEmitter for the combined event that captures all relevant navbar link interactions into one single event
   */
  srsaNavbarLinkClicked: EventEmitter<CustomEvent<ISrsaNavbarInternalCustomEvent<PointerEvent, string>>>;
}


@ProxyCmp({
  inputs: ['disabled', 'internalAriaLabel', 'internalId', 'internalTabIndex', 'isClickable', 'isLoading', 'size', 'src', 'text', 'tooltip']
})
@Component({
  selector: 'srsa-profile-photo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled', 'internalAriaLabel', 'internalId', 'internalTabIndex', 'isClickable', 'isLoading', 'size', 'src', 'text', 'tooltip'],
})
export class SrsaProfilePhoto {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['srsaProfilePhotoClicked']);
  }
}


import type { InternalCustomEvent as ISrsaProfilePhotoInternalCustomEvent } from '../ds-components-intapps-angular';

export declare interface SrsaProfilePhoto extends Components.SrsaProfilePhoto {
  /**
   * A unique event generated on button click identified by the internalId.
Is generated alongside (and not overwriting) the default click event.

The event name is the name of the method: srsaButtonClicked. This can be
overridden with @Event ({eventName: 'custom name'}) if desired

The custom event will contain a detail property, that contains the object passed
in as the argument for .emit(). This object contains the custom unique id of the
custom element instance, as well as the PointerEvent contents. This allows
a listener for srsaButtonClicked events to filter for specific buttons with this id.

The event cannot be named after the custom id itself while using Stencil's,@Event decorator,
as that is generated after the event definition is already processed.

Can be listened to via,@Listen https://stenciljs.com/docs/events#listen-decorator
   */
  srsaProfilePhotoClicked: EventEmitter<CustomEvent<ISrsaProfilePhotoInternalCustomEvent<PointerEvent | KeyboardEvent, string>>>;
}


@ProxyCmp({
  inputs: ['accordionClass', 'arrowDirection', 'disabled', 'dropdownMaxHeight', 'dropdownWidth', 'helper', 'internalAriaLabel', 'internalClass', 'internalId', 'isLoading', 'label', 'leadingIcon', 'options', 'overflowYScroll', 'required', 'requiredErrorMessage', 'selectContainerConfig', 'shouldFilter', 'shouldShowErrors', 'trailingIcon', 'validators', 'value']
})
@Component({
  selector: 'srsa-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['accordionClass', 'arrowDirection', 'disabled', 'dropdownMaxHeight', 'dropdownWidth', 'helper', 'internalAriaLabel', 'internalClass', 'internalId', 'isLoading', 'label', 'leadingIcon', 'options', 'overflowYScroll', 'required', 'requiredErrorMessage', 'selectContainerConfig', 'shouldFilter', 'shouldShowErrors', 'trailingIcon', 'validators', 'value'],
})
export class SrsaSelect {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['srsaSelectOptionClicked', 'change']);
  }
}


import type { InternalCustomEvent as ISrsaSelectInternalCustomEvent } from '../ds-components-intapps-angular';
import type { SrsaSelectOption as ISrsaSelectSrsaSelectOption } from '../ds-components-intapps-angular';

export declare interface SrsaSelect extends Components.SrsaSelect {
  /**
   * A unique event generated on select option click identified by the internalId.
Is generated alongside (and not overwriting) the default click event.

The event name is the name of the method: srsaButtonClicked. This can be
overridden with @Event ({eventName: 'custom name'}) if desired

The custom event will contain a detail property, that contains the object passed
in as the argument for .emit(). This object contains the custom unique id of the
custom element instance, as well as the PointerEvent contents. This allows
a listener for srsaButtonClicked events to filter for specific buttons with this id.

The event cannot be named after the custom id itself while using Stencil's,@Event decorator,
as that is generated after the event definition is already processed.

Can be listened to via,@Listen https://stenciljs.com/docs/events#listen-decorator
   */
  srsaSelectOptionClicked: EventEmitter<CustomEvent<ISrsaSelectInternalCustomEvent<MouseEvent, ISrsaSelectSrsaSelectOption>>>;

  change: EventEmitter<CustomEvent<ISrsaSelectInternalCustomEvent<MouseEvent, ISrsaSelectSrsaSelectOption>>>;
}


@ProxyCmp({
  inputs: ['buttonConfig', 'clearButtonText', 'disabled', 'dropdownContainerConfig', 'internalAriaLabel', 'internalId', 'isLoading', 'options', 'singleSort', 'sortByText', 'values']
})
@Component({
  selector: 'srsa-sort',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['buttonConfig', 'clearButtonText', 'disabled', 'dropdownContainerConfig', 'internalAriaLabel', 'internalId', 'isLoading', 'options', 'singleSort', 'sortByText', 'values'],
})
export class SrsaSort {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['change', 'srsaSortOptionClicked']);
  }
}


import type { InternalCustomEvent as ISrsaSortInternalCustomEvent } from '../ds-components-intapps-angular';
import type { SrsaSortValue as ISrsaSortSrsaSortValue } from '../ds-components-intapps-angular';

export declare interface SrsaSort extends Components.SrsaSort {
  /**
   * Emits the change event, which passes on the pointer event
emitted by srsa-button clicks
   */
  change: EventEmitter<CustomEvent<ISrsaSortInternalCustomEvent<PointerEvent, ISrsaSortSrsaSortValue[]>>>;
  /**
   * Emits the custom srsaSortOptionClicked event, which passes on the pointer event
emitted by srsa-button clicks
   */
  srsaSortOptionClicked: EventEmitter<CustomEvent<ISrsaSortInternalCustomEvent<PointerEvent, ISrsaSortSrsaSortValue[]>>>;
}


@ProxyCmp({
  inputs: ['clearButtonAriaLabel', 'disabled', 'helper', 'inputAriaLabel', 'internalClass', 'internalId', 'isClearButton', 'isLoading', 'label', 'leadingIcon', 'max', 'maxLength', 'min', 'minLength', 'name', 'required', 'shouldShowErrors', 'trailingIcon', 'type', 'validators', 'value']
})
@Component({
  selector: 'srsa-text-field',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['clearButtonAriaLabel', 'disabled', 'helper', 'inputAriaLabel', 'internalClass', 'internalId', 'isClearButton', 'isLoading', 'label', 'leadingIcon', 'max', 'maxLength', 'min', 'minLength', 'name', 'required', 'shouldShowErrors', 'trailingIcon', 'type', 'validators', 'value'],
})
export class SrsaTextField {
  protected el: HTMLElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
    proxyOutputs(this, this.el, ['change', 'srsaTextFieldChange']);
  }
}


import type { InternalCustomEvent as ISrsaTextFieldInternalCustomEvent } from '../ds-components-intapps-angular';
import type { ElementEvent as ISrsaTextFieldElementEvent } from '../ds-components-intapps-angular';

export declare interface SrsaTextField extends Components.SrsaTextField {
  /**
   * Triggered on a input event from the input field.
   */
  change: EventEmitter<CustomEvent<InputEvent>>;
  /**
   * Triggered on a change event from the input field. Wraps the event and attaches the component's
unique ID for easy identification.

Also triggered with a custom event when the clear button is used
   */
  srsaTextFieldChange: EventEmitter<CustomEvent<ISrsaTextFieldInternalCustomEvent<ISrsaTextFieldElementEvent<HTMLInputElement> | InputEvent | CustomEvent, string>>>;
}


